import React, { useCallback, useState } from 'react';
import { Check, Copy } from 'lucide-react';
import toast from 'react-hot-toast';

type Props = {
  text?: string | null;
  label?: string;
  className?: string;
  showToast?: boolean;
};

const CopyLinkButton: React.FC<Props> = ({
  text,
  label = 'Copy',
  className = '',
  showToast = true,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(async () => {
    if (!text) return;
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      if (showToast) toast.success('Copied to clipboard');
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error('Could not copy');
    }
  }, [text, showToast]);

  return (
    <div className={`relative inline-flex ${className}`}>
      <button
        type="button"
        onClick={() => void handleCopy()}
        disabled={!text}
        className="inline-flex items-center gap-1 rounded-md px-2 py-1 text-sm text-blue-600 transition hover:bg-blue-50 disabled:opacity-40 dark:text-blue-400 dark:hover:bg-blue-900/20"
        aria-label={label}
      >
        {copied ? (
          <Check className="h-4 w-4 text-green-600 dark:text-green-400" />
        ) : (
          <Copy className="h-4 w-4" />
        )}
        <span className="hidden sm:inline">{copied ? 'Copied' : label}</span>
      </button>
    </div>
  );
};

export default CopyLinkButton;
